import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { NakshatramSubTempleService } from './nakshatram-sub-temple.service';

export const useGetNakshatramSubTemples = (
  nakshatramId = undefined,
  page = 1,
  limit = 10
) => {
  return useQuery({
    queryKey: ['nakshatramSubTempleService.getAll', nakshatramId, page, limit],
    queryFn: () => NakshatramSubTempleService.getAll(nakshatramId, page, limit),
  });
};

export const useCreateNakshatramSubTemple = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ nakshatramId, subTempleIds }) =>
      NakshatramSubTempleService.create(nakshatramId, subTempleIds),
    onSuccess: () => {
      queryClient.invalidateQueries('nakshatramSubTempleService.getAll');
    },
  });
};

export const useDeleteNakshatramSubTemple = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }) => NakshatramSubTempleService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries('nakshatramSubTempleService.getAll');
    },
  });
};
